export default {
  全部交易产品: "All Trading Products",
};
